/** @format */

module.exports = {
  publicKey: "dc27636329474b76ec17e672ddd49d53",
  hostnameId: "nyspins",
};



// WEBPACK FOOTER //
// ./src/partners/config/partner.js